/* Shopify owns the saved market choice. Do not overwrite it from an IP guess. */
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.sb-country-form').forEach((form) => {
        form.addEventListener('submit', () => {
            const detectedHandoff = form.dataset.sbMarketHandoff === 'detected';
            delete form.dataset.sbMarketHandoff;
            if (detectedHandoff) return;
            try {
                sessionStorage.setItem('sb-market-choice', 'manual');
            } catch { /* Native form still works. */
            }
            const country = form.querySelector('select[name="country_code"]')?.value;
            if (/^[A-Z]{2}$/.test(country || '')) {
                try {
                    localStorage.setItem('sb-market-choice-v1', country);
                } catch { /* Shopify still saves the native selection. */
                }
            }
        });
    });
    const notice = document.querySelector('[data-sb-country-notice]');
    if (!notice) return;
    try {
        if (sessionStorage.getItem('sb-market-choice')) return;
    } catch {
        return;
    }
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 4000);
    const root = window.Shopify?.routes?.root || '/';
    fetch(`${root}browsing_context_suggestions.json?country[enabled]=true&country[exclude]=${encodeURIComponent(notice.dataset.country)}`, {signal: controller.signal})
        .then((response) => response.ok ? response.json() : null)
        .then((data) => {
            const recommendation = data?.suggestions?.find((item) => item.parts?.country)?.parts.country;
            const select = notice.querySelector('select');
            if (!recommendation || !['CA', 'US'].includes(recommendation.handle) || recommendation.handle === notice.dataset.country) return;
            if (!Array.from(select.options).some((option) => option.value === recommendation.handle)) return;
            select.value = recommendation.handle;
            notice.hidden = false;
        })
        .catch(() => { /* The visible native selector remains available. */
        })
        .finally(() => clearTimeout(timeout));
    notice.querySelector('[data-sb-country-dismiss]').addEventListener('click', () => {
        notice.hidden = true;
        try {
            sessionStorage.setItem('sb-market-choice', 'dismissed');
        } catch { /* No forced redirect. */
        }
        if (/^[A-Z]{2}$/.test(notice.dataset.country || '')) {
            try {
                localStorage.setItem('sb-market-choice-v1', notice.dataset.country);
            } catch { /* The current country remains selected. */
            }
        }
    });
});
